import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

const WORDS = [
    "Safety Case Management",
    "Assurance",
    "Audit Trails",
    "Action Tracker",
    "Offline-First",
    "Benchmarking",
    "Real-Time Visibility",
    "Automated Workflows",
];

const Row = () => (
    <div className="flex items-center shrink-0">
        {WORDS.map((w, i) => (
            <div key={`${w}-${i}`} className="flex items-center shrink-0">
                <span className="font-display text-4xl md:text-6xl lg:text-7xl font-extrabold tracking-tight text-white whitespace-nowrap">
                    {w}
                </span>
                <span className="mx-8 md:mx-12 w-3 h-3 md:w-4 md:h-4 bg-[#0052CC] rotate-45 shrink-0" />
            </div>
        ))}
    </div>
);

export const Marquee = () => {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({
        target: ref,
        offset: ["start end", "end start"],
    });
    // subtle scroll-linked drift layered on the CSS auto-scroll
    const x = useTransform(scrollYProgress, [0, 1], ["2%", "-8%"]);

    return (
        <section ref={ref} className="relative bg-[#091524] py-10 md:py-14 overflow-hidden border-y border-white/10">
            <motion.div style={{ x }} className="w-max">
                <div className="flex w-max marquee-track">
                    <Row />
                    <Row />
                </div>
            </motion.div>
            {/* edge fades */}
            <div className="pointer-events-none absolute inset-y-0 left-0 w-24 md:w-40 bg-gradient-to-r from-[#091524] to-transparent" />
            <div className="pointer-events-none absolute inset-y-0 right-0 w-24 md:w-40 bg-gradient-to-l from-[#091524] to-transparent" />
        </section>
    );
};
